export class ServiceCenter{
    
    public id : number = 0;
    public name : string = '';
    public description  : string = '';

    public timezone : string = '';
    public latitude: number = 0;
    public longitude: number = 0;

    public constructor(init?:Partial<ServiceCenter>) {
        Object.assign(this, init);
    }

}